import { Modal as NextUIModal, ModalProps as NextUIModalProps } from "@heroui/react";

interface ModalProps extends NextUIModalProps {}

export const Modal = ({ children, ...props }: ModalProps) => {
  return (
    <>
      <NextUIModal {...props}>
        {children}
      </NextUIModal>
    </>
  );
};